import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/wx/tabUserWxInfo/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/wx/tabUserWxInfo/get/${params.id}`)
  },
  //根据userwxid查询单个信息
  getByWxid(params) {
    return axios.get(`${base.bs}/admin/wx/tabUserWxInfo/getByWxid/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/wx/tabUserWxInfo/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/wx/tabUserWxInfo/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.get(`${base.bs}/admin/wx/tabUserWxInfo/batchDel?ids=${params.ids}`,null)
  },
  //批量删除
  setIsPublic(params) {
    return axios.get(`${base.bs}/admin/wx/tabUserWxInfo/setIsPublic?ispublic=${params.ispubic}&ids=${params.ids}`,null)
  },
  //保存评价
  savePj(params) {
    return axios.post(`${base.bs}/admin/wx/tabUserWxInfo/savepj`,params)
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/tabUserWxInfo.js